import About from './About';

export default About;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/index.js